<div class="bg-[#0A0E1F] text-white py-6 flex flex-col items-center">
<h2 class="lg:text-[22px] text-white font-libre font-bold text-[18px] leading-[27px]" *ngIf="datashow">
    <span class="text-[#19E4E0] border-b-2 border-[#19E4E0]">Elite Arcade</span>
    Token Drops
  </h2>
  <h1 class="text-2xl lg:text-[42px] font-bold mt-2" *ngIf="datashow">
    Daily Mystery Drops, Endless Thrills!
  </h1>
  <p class="mt-3 text-[12px] lg:text-[16px] text-gray-400 text-center max-w-2xl px-4" *ngIf="datashow">
    Choose your reward tier and let our platform elevate your day with exciting daily 
    giveaways and milestone opportunities.
  </p>
  <!-- (click)="RedirectToLogin()" -->
  <!-- <div class="flex mt-2 lg:mt-8 px-4 py-2 bg-transparent lg:bg-[#1B223B] space-x-4" *ngIf="datashow">
    <button class="px-5 py-2 rounded-lg font-medium border border-gray-400" [class.bg-[#19E4E0]]="activeTab === 'all'"
      [class.text-black]="activeTab === 'all'" (click)="activeTab = 'all'">
      All Lotteries
    </button>

    <button class="px-5 py-2 rounded-lg font-medium border border-gray-400"
      [class.bg-[#19E4E0]]="activeTab === 'upcoming'" [class.text-black]="activeTab === 'upcoming'"
      (click)="activeTab = 'upcoming'">
      Upcoming Lotteries
    </button>
  </div> -->

  <!-- Grid Container -->
  <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 px-6 gap-y-6 gap-x-4 mt-12 lg:mt-0 w-full"
    [ngClass]="{ 'container mx-auto max-w-7xl': datashow }">
    <!-- ✅ Skeleton Loader -->
    <ng-container *ngIf="isLoading && !showNoDataFlag">
      <div *ngFor="let loader of loaderArray"
        class="mt-4 lg:mt-0 min-h-[30vh] lg:min-h-[60vh] flex items-center justify-center">
        <div class="relative w-[305px]">
          <div class="border-2 border-cyan-400 rounded-[18px] p-6 bg-[#0b1720] animate-pulse space-y-4">
            <div
              class="w-full h-12 bg-gray-700 rounded flex items-center justify-center text-white text-sm sm:text-base font-medium">
              Lottery data loading...
            </div>
            <div class="h-4 w-36 mx-auto bg-gray-700 rounded"></div>
            <div class="h-10 w-full max-w-[280px] mx-auto bg-gray-700 rounded"></div>
            <div class="h-6 w-32 mx-auto bg-gray-700 rounded"></div>
            <div class="h-10 w-full bg-gray-700 rounded"></div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="lotteryList.length > 0">
      <div *ngFor="let card of lotteryList; trackBy: trackByFn"
        class="group mt-2 relative w-auto h-[390px] md:h-[480px] cursor-pointer rounded-[25px] overflow-hidden">
        <!-- 1. Background Overlay -->
        <div class="absolute inset-0 bg-[#0f1423]/95 backdrop-blur-2xl z-0"></div>

        <!-- 2. ORIGINAL DYNAMIC BORDER (Wahi Logic) -->
        <div class="absolute inset-0 rounded-[25px] border-[2px] z-10 pointer-events-none" [ngStyle]="{
            background:
              'linear-gradient(rgba(15,20,35,1), rgba(15,20,35,1)) padding-box, ' +
              'linear-gradient(to right, transparent, ' +
              color +
              ' 50%, transparent) border-box, ' +
              'linear-gradient(to bottom, ' +
              color +
              '40, ' +
              color +
              '10 50%, ' +
              color +
              '40) border-box',
          }" style="border-color: transparent"></div>

        <!-- 3. Inner Content -->
        <div class="relative z-20 h-full w-full p-2 sm:p-4 flex flex-col items-center" [ngStyle]="{
            background:
              'linear-gradient(to bottom, ' +
              color +
              '08, ' +
              color +
              '15, ' +
              color +
              '08)',
          }">
          <!-- Winning Amount -->
          <div class="text-center mt-2">
            <p class="text-[14px] sm:text-[16px] uppercase text-white font-bold tracking-widest mt-1">
              Jackpot Prize
            </p>

            <!-- UPTO badge style -->
            <div
              class="my-1 inline-block px-3 py-[2px] rounded-full bg-gradient-to-r from-yellow-500/20 via-yellow-300/30 to-yellow-500/20 border border-yellow-400/40 backdrop-blur-sm">
              <span class="text-[18px] sm:text-[22px] font-bold tracking-widest text-yellow-300">
                UPTO
              </span>
            </div>

            <h2
              class="text-[32px] sm:text-[60px] font-black tracking-tight leading-none text-transparent bg-clip-text bg-gradient-to-b from-yellow-400 via-yellow-300 to-yellow-600 drop-shadow-[2px_2px_2px_rgba(0,0,0,0.4)]">
              ${{ card.WinnersAmount }}
            </h2>
          </div>

          <!-- Lottery Name (Simplified for better readability than SVG) -->
          <div class="w-full text-center mt-4" *ngIf="card.Status === 'Open'">
            <span
              class="text-md sm:text-lg font-extrabold uppercase tracking-[0.2em] text-white group-hover:text-cyan-200 transition-colors">
              Hurry Up
            </span>
          </div>

          <div class="w-full text-center mt-4" *ngIf="card.Status === 'Close'">
            <span
              class="text-[8px] sm:text-lg font-extrabold uppercase tracking-[0.2em] text-white group-hover:text-cyan-200 transition-colors">
              YOUR REWARD IS READY!
            </span>
          </div>

          <!-- Timer Section -->
          <div class="w-full">
            <div *ngIf="card.Status === 'Open'"
              class="mx-auto w-[90%] p-[1px] rounded-lg bg-gradient-to-r from-white/10 to-white/5">
              <div class="flex items-center justify-center gap-1 sm:gap-2 bg-black/40 rounded-lg py-1 shadow-inner">
                <span class="font-mono text-lg sm:text-2xl text-cyan-200">{{
                  card.time.hh
                  }}</span>
                <span class="text-white/30 text-[16px] sm:text-2xl">:</span>
                <span class="font-mono text-lg sm:text-2xl text-cyan-200">{{
                  card.time.mm
                  }}</span>
                <span class="text-white/30 text-[16px] sm:text-2xl">:</span>
                <span class="font-mono text-lg sm:text-2xl text-cyan-200">{{
                  card.time.ss
                  }}</span>
              </div>
            </div>

            <!-- Sparkle Dots -->
            <div class="absolute inset-0 pointer-events-none">
              <span class="absolute w-1 h-1 bg-red-400 rounded-full top-10 left-5"></span>
              <span class="absolute w-1.5 h-1.5 bg-green-400 rounded-full top-16 left-20"></span>
              <span class="absolute w-1 h-1 bg-blue-400 rounded-full top-5 right-10"></span>
              <span class="absolute w-2 h-2 bg-yellow-400 rounded-full top-20 right-5"></span>
              <span class="absolute w-1 h-1 bg-purple-400 rounded-full top-3 left-32"></span>

              <!-- Additional dots -->
              <span class="absolute w-1.5 h-1.5 bg-pink-400 rounded-full top-12 left-28"></span>
              <span class="absolute w-1 h-1 bg-indigo-400 rounded-full top-8 right-20"></span>
              <span class="absolute w-2 h-2 bg-teal-400 rounded-full top-18 left-40"></span>
              <span class="absolute w-1 h-1 bg-orange-400 rounded-full top-6 right-32"></span>
              <span class="absolute w-1.5 h-1.5 bg-cyan-400 rounded-full top-22 left-10"></span>
              <span class="absolute w-1 h-1 bg-lime-400 rounded-full top-4 right-5"></span>
            </div>
          </div>

          <div class="relative text-center py-4">
            <!-- Text -->
            <h2
              class="text-2xl sm:text-3xl font-bold bg-gradient-to-r from-yellow-400 via-orange-400 to-yellow-500 bg-clip-text text-transparent drop-shadow-[0_2px_4px_rgba(0,0,0,0.5)]">
              {{ card.LotteryName | uppercase }}
            </h2>
            <p *ngIf="card.Status === 'Open'"
              class="text-lg sm:text-md font-semibold text-white drop-shadow-[0_1px_2px_rgba(0,0,0,0.5)]">
              Buy to Claim Your Prize!
            </p>

            <p *ngIf="card.Status === 'Close'"
              class="text-lg sm:text-md font-semibold text-white drop-shadow-[0_1px_2px_rgba(0,0,0,0.5)]">
              Tap to Claim Your Prize!
            </p>
          </div>

          <div class="flex justify-center items-center w-full mb-2 px-1">
            <span
              class="bg-white/10 backdrop-blur-md px-3 py-1 rounded-full text-[#F2C749] font-bold text-[14px] sm:text-[13px]">
              Only For ${{ card.TicketPrice }}
            </span>
          </div>
          <!-- CTA Button -->
          <!-- BUY NOW -->
          <button *ngIf="card.Status === 'Open' && card.IsDisabled === false" (click)="BuyTicket(card)"
            class="relative w-full flex items-center justify-center gap-1.5 py-3 rounded-full bg-white/3 border border-white/10 backdrop-blur-md text-white font-medium text-[16px] transition-all hover:bg-white/10 hover:border-white/40 shadow-[inset_0_0_8px_rgba(255,255,255,0.1),0_3px_8px_rgba(0,0,0,0.4)]">
            <span
              class="absolute inset-0 rounded-full bg-gradient-to-b from-white/20 to-transparent pointer-events-none"></span>

            <span class="relative flex items-center gap-1.5">
              <span class="font-bold">Buy Now</span>
            </span>
          </button>

          <!-- BUYING TIME OVER -->
          <button *ngIf="card.Status === 'Open' && card.IsDisabled" disabled
            class="relative w-full flex items-center justify-center gap-1.5 py-3 rounded-full bg-white/3 border border-white/10 backdrop-blur-md text-white font-medium text-[16px] opacity-70 cursor-not-allowed shadow-[inset_0_0_8px_rgba(255,255,255,0.1),0_3px_8px_rgba(0,0,0,0.4)]">
            <span
              class="absolute inset-0 rounded-full bg-gradient-to-b from-white/20 to-transparent pointer-events-none"></span>

            <span class="relative flex items-center gap-1.5">
              <span class="font-bold">Buying time over</span>
            </span>
          </button>

          <!-- SEE DETAILS -->
          <button *ngIf="card.Status === 'Close'"
            class="relative w-full flex items-center justify-center gap-1.5 py-3 rounded-full bg-white/3 border border-white/10 backdrop-blur-md text-white font-medium text-[16px] transition-all hover:bg-white/10 hover:border-white/40 shadow-[inset_0_0_8px_rgba(255,255,255,0.1),0_3px_8px_rgba(0,0,0,0.4)]">
            <span
              class="absolute inset-0 rounded-full bg-gradient-to-b from-white/20 to-transparent pointer-events-none"></span>

            <span class="relative flex items-center gap-1.5">
              <span class="font-bold">See Details</span>
            </span>
          </button>

          <!-- LOGIN CASE -->
          <button *ngIf="datashow" (click)="RedirectToLogin()"
            class="relative w-full flex items-center justify-center gap-1.5 py-3 rounded-full bg-white/3 border border-white/10 backdrop-blur-md text-white font-medium text-[16px] transition-all hover:bg-white/10 hover:border-white/40 shadow-[inset_0_0_8px_rgba(255,255,255,0.1),0_3px_8px_rgba(0,0,0,0.4)]">
            <span
              class="absolute inset-0 rounded-full bg-gradient-to-b from-white/20 to-transparent pointer-events-none"></span>

            <span class="relative flex items-center gap-1.5">
              <span class="font-bold">Buy Now</span>
            </span>
          </button>
        </div>
      </div>
    </ng-container>

    <div *ngIf="lotteryList.length == 4" class="flex justify-center mt-8 mb-6 w-full col-span-full">
      <button (click)="toggleShowAllLottery()"
        class="px-6 py-2 --button  text-white font-semibold rounded-lg shadow-md hover:opacity-90 transition">
        {{ showAll ? "Show Less" : "Show More" }}
      </button>
    </div>
  </div>

  <div *ngIf="!isLoading && showNoDataFlag" class="flex justify-center items-center">
    <div class="relative max-w-[405px]">
   <div
        class="border-2 border-[#7de7e5] rounded-[18px] p-6 bg-[#0b1720] text-center flex flex-col items-center justify-center space-y-4 shadow-[0_0_20px_rgba(25,228,224,0.2)]">
        <p class="text-white text-lg font-semibold tracking-wide">
          Stay tuned for new token drops
        </p>
        <p class="text-gray-400 text-sm max-w-[250px]">
          Please check back later — new gaming events are added soon.
        </p>
      </div>
    </div>
  </div>
</div>